import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DeviceProductTreePicker from '../components/DeviceProductTreePicker';
import {
  sendOnServisOtp,
  verifyOnServisOtp,
  createOnServisKaydi,
} from '../services/onServisKaydiService';
import './LoginPage.css';
import './BayiOnServisWizardPage.css';

const STEPS = ['Müşteri Bilgileri', 'Telefon Doğrulama', 'Ürün Bilgileri'];

function normalizePhoneInput(value) {
  return String(value || '').replace(/\D/g, '').slice(0, 10);
}

function BayiOnServisWizardPage({ onLogout }) {
  const [step, setStep] = useState(0);
  const [musteriAd, setMusteriAd] = useState('');
  const [musteriSoyad, setMusteriSoyad] = useState('');
  const [telefon, setTelefon] = useState('');
  const [otpKod, setOtpKod] = useState('');
  const [dogrulamaToken, setDogrulamaToken] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [seriNumarasi, setSeriNumarasi] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successInfo, setSuccessInfo] = useState(null);

  useEffect(() => {
    if (countdown <= 0) return undefined;
    const timer = setInterval(() => {
      setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, [countdown]);

  const handleStep1Next = () => {
    setError('');
    if (!musteriAd.trim() || !musteriSoyad.trim()) {
      setError('Müşteri adı ve soyadı gereklidir');
      return;
    }
    if (!/^5[0-9]{9}$/.test(telefon)) {
      setError('Geçerli bir GSM numarası giriniz (5XXXXXXXXX)');
      return;
    }
    setStep(1);
  };

  const handleSendOtp = async () => {
    setError('');
    setLoading(true);
    try {
      const res = await sendOnServisOtp({
        musteriAd: musteriAd.trim(),
        musteriSoyad: musteriSoyad.trim(),
        telefon,
      });
      if (res?.basarili === false) {
        setError(res.mesaj || 'SMS gönderilemedi');
        return;
      }
      setOtpSent(true);
      setCountdown(res?.veri?.gecerlilikSuresiSaniye || 120);
    } catch (err) {
      setError(err?.message || err?.mesaj || 'SMS gönderilemedi');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    setError('');
    if (!/^[0-9]{6}$/.test(otpKod.trim())) {
      setError('6 haneli doğrulama kodunu giriniz');
      return;
    }
    setLoading(true);
    try {
      const res = await verifyOnServisOtp({ telefon, kod: otpKod.trim() });
      if (res?.basarili === false) {
        setError(res.mesaj || 'Doğrulama başarısız');
        return;
      }
      setDogrulamaToken(res?.veri?.dogrulamaToken || '');
      setStep(2);
    } catch (err) {
      setError(err?.message || err?.mesaj || 'Doğrulama başarısız');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    setError('');
    if (!selectedProduct?.id && !selectedProduct?._id) {
      setError('Lütfen bir ürün seçiniz');
      return;
    }
    setLoading(true);
    try {
      const res = await createOnServisKaydi({
        dogrulamaToken,
        icerikId: selectedProduct.id || selectedProduct._id,
        seriNumarasi: seriNumarasi.trim() || undefined,
      });
      if (res?.basarili === false) {
        setError(res.mesaj || 'Kayıt oluşturulamadı');
        return;
      }
      const kayit = res?.veri?.onServisKaydi;
      setSuccessInfo({
        musteriAd: kayit?.musteriAd || musteriAd.trim(),
        musteriSoyad: kayit?.musteriSoyad || musteriSoyad.trim(),
        telefon: kayit?.telefon || telefon,
        urunAdi: kayit?.urunAdi || selectedProduct.icerikAdi || selectedProduct.ad || 'Ürün',
        seriNumarasi: kayit?.seriNumarasi || seriNumarasi.trim() || null,
      });
      setStep(0);
      setMusteriAd('');
      setMusteriSoyad('');
      setTelefon('');
      setOtpKod('');
      setDogrulamaToken('');
      setOtpSent(false);
      setCountdown(0);
      setSelectedProduct(null);
      setSeriNumarasi('');
    } catch (err) {
      setError(err?.message || err?.mesaj || 'Kayıt oluşturulamadı');
    } finally {
      setLoading(false);
    }
  };

  const dismissSuccess = () => setSuccessInfo(null);

  const selectedProductId = selectedProduct?.id || selectedProduct?._id || '';

  return (
    <div className="login-container">
      <div className={`login-card bayi-wizard-card${step === 2 ? ' bayi-wizard-card--wide' : ''}`}>
        <div className="login-header">
          <h1>Ön Servis Kaydı</h1>
          <p>Bayi Yönetim Sistemi</p>
        </div>

        {successInfo && (
          <div className="bayi-success-card" role="status">
            <div className="bayi-success-card-icon">✓</div>
            <div className="bayi-success-card-body">
              <strong>Ön servis kaydı başarıyla oluşturuldu</strong>
              <p>
                {successInfo.musteriAd} {successInfo.musteriSoyad} — {successInfo.telefon}
              </p>
              <p>
                Ürün: {successInfo.urunAdi}
                {successInfo.seriNumarasi ? ` · Seri: ${successInfo.seriNumarasi}` : ''}
              </p>
              <p className="bayi-success-card-hint">
                Müşteri hizmetleri en kısa sürede müşteri ile iletişime geçecektir.
              </p>
            </div>
            <button type="button" className="bayi-success-dismiss" onClick={dismissSuccess} aria-label="Kapat">
              ×
            </button>
          </div>
        )}

        <div className="bayi-wizard-steps">
          {STEPS.map((label, index) => (
            <div
              key={label}
              className={`bayi-wizard-step ${index === step ? 'active' : ''} ${index < step ? 'done' : ''}`}
            >
              <span>{index + 1}</span>
              <small>{label}</small>
            </div>
          ))}
        </div>

        {error && (
          <div className="error-message" role="alert">
            {error}
          </div>
        )}

        {step === 0 && (
          <div className="login-form">
            <div className="form-group">
              <label htmlFor="musteriAd">Müşteri Adı</label>
              <input
                id="musteriAd"
                type="text"
                value={musteriAd}
                onChange={(e) => setMusteriAd(e.target.value)}
                placeholder="Ad"
                maxLength={50}
              />
            </div>
            <div className="form-group">
              <label htmlFor="musteriSoyad">Müşteri Soyadı</label>
              <input
                id="musteriSoyad"
                type="text"
                value={musteriSoyad}
                onChange={(e) => setMusteriSoyad(e.target.value)}
                placeholder="Soyad"
                maxLength={50}
              />
            </div>
            <div className="form-group">
              <label htmlFor="telefon">Telefon</label>
              <input
                id="telefon"
                type="tel"
                value={telefon}
                onChange={(e) => setTelefon(normalizePhoneInput(e.target.value))}
                placeholder="5XXXXXXXXX"
                maxLength={10}
              />
            </div>
            <button type="button" className="login-button" onClick={handleStep1Next}>
              Devam Et
            </button>
          </div>
        )}

        {step === 1 && (
          <div className="login-form">
            <p className="bayi-wizard-info">
              {musteriAd} {musteriSoyad} — {telefon}
            </p>
            {!otpSent ? (
              <button type="button" className="login-button" disabled={loading} onClick={handleSendOtp}>
                {loading ? 'Gönderiliyor...' : 'SMS Doğrulama Kodu Gönder'}
              </button>
            ) : (
              <>
                <div className="form-group">
                  <label htmlFor="otpKod">Doğrulama Kodu</label>
                  <input
                    id="otpKod"
                    type="text"
                    value={otpKod}
                    onChange={(e) => setOtpKod(e.target.value.replace(/\D/g, '').slice(0, 6))}
                    placeholder="6 haneli kod"
                    maxLength={6}
                  />
                </div>
                {countdown > 0 && (
                  <p className="bayi-wizard-countdown">Kalan süre: {countdown} sn</p>
                )}
                <button type="button" className="login-button" disabled={loading} onClick={handleVerifyOtp}>
                  {loading ? 'Doğrulanıyor...' : 'Doğrula ve Devam Et'}
                </button>
                <button
                  type="button"
                  className="bayi-wizard-secondary-btn"
                  disabled={loading || countdown > 0}
                  onClick={handleSendOtp}
                >
                  Kodu Tekrar Gönder
                </button>
              </>
            )}
            <button type="button" className="bayi-wizard-secondary-btn" onClick={() => setStep(0)}>
              Geri
            </button>
          </div>
        )}

        {step === 2 && (
          <div className="login-form">
            <p className="bayi-wizard-info">
              {musteriAd} {musteriSoyad} — {telefon}
            </p>
            <div className="bayi-product-tree-wrap">
              <DeviceProductTreePicker
                selectedId={selectedProductId}
                onSelect={setSelectedProduct}
                disabled={loading}
              />
            </div>
            {selectedProduct && (
              <div className="bayi-selected-product" role="status">
                <span className="bayi-selected-product-label">Seçilen ürün</span>
                <strong>
                  {selectedProduct.icerikAdi || selectedProduct.urunAdi || selectedProduct.ad || 'Ürün'}
                </strong>
                {(selectedProduct.icerikKodu || selectedProduct.urunKodu) && (
                  <span className="bayi-selected-product-code">
                    {selectedProduct.icerikKodu || selectedProduct.urunKodu}
                  </span>
                )}
              </div>
            )}
            <div className="form-group">
              <label htmlFor="seriNo">Seri Numarası (Opsiyonel)</label>
              <input
                id="seriNo"
                type="text"
                value={seriNumarasi}
                onChange={(e) => setSeriNumarasi(e.target.value)}
                placeholder="Cihaz seri numarası"
                maxLength={100}
              />
            </div>
            <button type="button" className="login-button" disabled={loading} onClick={handleSubmit}>
              {loading ? 'Gönderiliyor...' : 'Gönder'}
            </button>
            <button type="button" className="bayi-wizard-secondary-btn" onClick={() => setStep(1)}>
              Geri
            </button>
          </div>
        )}

        <div className="bayi-wizard-footer">
          <Link to="/">Ana Sayfa</Link>
          <button type="button" className="bayi-wizard-logout" onClick={onLogout}>
            Çıkış Yap
          </button>
        </div>
      </div>
    </div>
  );
}

export default BayiOnServisWizardPage;
